var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtocol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m17.67,22H6.32c-2.39,0-4.32-1.94-4.33-4.32V6.33c0-2.39,1.94-4.32,4.33-4.33h11.35c2.39,0,4.32,1.94,4.32,4.33v11.35c0,2.39-1.94,4.32-4.32,4.33M6.32,4.08c-1.24,0-2.24,1.01-2.24,2.24v11.35c0,1.24,1.01,2.24,2.24,2.24h11.35c1.24,0,2.24-1,2.24-2.24V6.33c0-1.24-1-2.24-2.24-2.24H6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m17.5,15.79H6.39c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h11.1c.35,0,.62.28.62.62s-.28.62-.62.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m17.5,8.7H6.39c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h11.1c.35,0,.62.28.62.62s-.28.62-.62.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m17.5,12.44H6.39c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h11.1c.35,0,.62.28.62.62s-.28.62-.62.62"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocol);
export default __webpack_public_path__ + "static/media/protocol.787e4355ac089fa8888a2dfd2fb3ed50.svg";
export { ForwardRef as ReactComponent };